import React, { FC } from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select, { SelectProps } from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, FormHelperText, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';
import { ListSubheader } from '@material-ui/core';

export type OptionType = {
  value: string | number;
  label: string;
  groupeLabel?: string;
};

export type OptionsGrouped = {
  groupeLabel: string;
  options: OptionType[];
};

interface CustomSelectProps {
  label: string;
  options?: OptionType[];
  optionsgrouped?: OptionsGrouped[];
  errorSelect?: boolean;
  helperText?: string;
  loading?: boolean;
}

const CustomSelect: FC<CustomSelectProps & SelectProps> = (props) => {
  const classes = useStyles();
  return (
    <>
      {props.options && (
        <FormControl
          variant="outlined"
          required={props.required}
          fullWidth
          className={classes.formControl}
          disabled={props.loading || props.disabled}
          error={props.errorSelect}>
          <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
          <Select
            {...props}
            disabled={props.loading || props.disabled}
            endAdornment={
              props.loading ? <CircularProgress size={20} /> : null
            }>
            {props.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{props.helperText}</FormHelperText>
        </FormControl>
      )}

      {props.optionsgrouped && (
        <FormControl
          variant="outlined"
          required={props.required}
          fullWidth
          className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
          <Select
            {...props}
            disabled={props.loading || props.disabled}
            endAdornment={
              props.loading ? <CircularProgress size={20} /> : null
            }>
            {props.optionsgrouped.map((group) => [
              <ListSubheader>{group.groupeLabel}</ListSubheader>,
              group.options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              )),
            ])}
          </Select>
        </FormControl>
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
  }),
);

export default CustomSelect;
